import { render, staticRenderFns } from "./VItemCounter.vue?vue&type=template&id=3e82c906&scoped=true&"
import script from "./VItemCounter.vue?vue&type=script&lang=js&"
export * from "./VItemCounter.vue?vue&type=script&lang=js&"
import style0 from "./VItemCounter.vue?vue&type=style&index=0&id=3e82c906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e82c906",
  null
  
)

export default component.exports